export function getRootIdFromUrl(defaultRootId = 1) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get('rootId') || params.get('parentId');

  const id = Number(value);

  return Number.isFinite(id) && id > 0 ? id : defaultRootId;
}